module.exports = __webpack_public_path__ + "static/zocket-slider-8498aec60b0cfef8aa3e579217c0d144.png";